module.exports = __webpack_public_path__ + "static/fit_flare-960ebf9193834d004790fcba5eac63fd.png";